/* eslint-disable react/react-in-jsx-scope */
/* ================= Application Details ================= */
export const documentCaseColumns = [
  {
    header: (
      <div className="caseid-header">
        <span>Case ID</span>
      </div>
    ),
    accessor: "caseId",
    render: (value, row, _, onRowSelect) => (
      <div className="caseid-with-checkbox">
        <input
          type="checkbox"
          checked={onRowSelect?.selected?.some((r) => r.caseId === row.caseId)}
          onChange={() => onRowSelect(row)}
        />
        <span>{value}</span>
      </div>
    ),

  },
  { accessor: "submitDate", header: "Submit Date" },
  { accessor: "origin", header: "Origin" },
  { accessor: "firstName", header: "First Name" },
  { accessor: "lastName", header: "Last Name" },
  { accessor: "caseManager", header: "Case Manager" },
  { accessor: "updatedAt", header: "Updated At" },
  { accessor: "notes", header: "Notes" },
];

export const documentCaseStaticRow = {
  caseId: "-",
  submitDate: "-",
  origin: "-",
  firstName: "-",
  lastName: "-",
  caseManager: "-",
  updatedAt: "-",
  notes: "-",
};

/* ================= Document Quality ================= */
export const documentQualityColumns = (setOpenDoc) => [
  {
    header: "Case ID",
    accessor: "caseId",
    render: (_, row, __, onRowSelect) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <input
          type="checkbox"
          checked={onRowSelect?.selected?.some(
            (r) => r.documentId === row.documentId,
          )}
          onChange={() => onRowSelect(row)}
        />
        <span>{row.caseId}</span>
        {' '}
      </div>
    ),
  },
  { header: "Document Type", accessor: "documentType" },
  { header: "Document ID", accessor: "documentId" },
  { header: "Submit Date", accessor: "submitDate" },
  { header: "File Size", accessor: "fileSize" },
  {
    header: "Document Name",
    accessor: "documentName",
    render: (value, row) => (row.fileUrl ? (
      <span
        onClick={() => setOpenDoc({
          fileUrl: row.fileUrl,
          documentName: row.documentName,
        })}
        style={{
          color: "#007bff",
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        {value}
      </span>
    ) : (
      value
    )),
  },
  { header: "Description", accessor: "description" },
  { header: "Notes", accessor: "notes" },
];
